export default "__VITE_ASSET__BWU7H2ZD__"